import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NtsAppRootComponent } from '@nts/std';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent extends NtsAppRootComponent {

}
